// extracted by mini-css-extract-plugin
export default {"hovertext":"header_hovertext__HQcE6","header":"header_header__XQ+Dt","header_firstRow":"header_header_firstRow__LRt1z"};